import ModifiedProduct from '../model/ModifiedProduct';
import Quartiles from '../model/Quartiles';
import { ErrorStatus } from '../utils/enums/error';
import { base_url } from '../utils/variables';

export async function getDetailedSimilarProducts(id: string) {
  const fullUrl = base_url + 'products/detailed/similar/?doc_id=' + id;

  try {
    const response = await fetch(fullUrl, {
      method: 'GET',
    });

    if (!response.ok) {
      return ErrorStatus.NOT_FOUND;
    }

    let res = await response.json();

    return res;
  } catch (error) {
    console.error('Error fetching data:', error);
    return ErrorStatus.INTERNAL_ERROR;
  }
}

export async function getProductsQuartiles(): Promise<Quartiles> {
  const fullUrl = base_url + 'quartiles';

  try {
    const response = await fetch(fullUrl, {
      method: 'GET',
    });

    if (!response.ok) {
      return {
        global_quartiles: [],
        sub_category_quartiles: {},
        product_category_quartiles: {},
      };
    }

    let res = await response.json();

    return res;
  } catch (error) {
    console.error('Error fetching data:', error);
    return {
      global_quartiles: [],
      sub_category_quartiles: {},
      product_category_quartiles: {},
    };
  }
}

export async function getProductsCategories(): Promise<any> {
  const fullUrl = base_url + 'categories';

  try {
    const response = await fetch(fullUrl, {
      method: 'GET',
    });

    if (!response.ok) {
      return {};
    }

    let res = await response.json();
    return res;
  } catch (error) {
    console.error('Error fetching data:', error);
    return {};
  }
}

export async function sendDetailedProduct(detailedProduct: ModifiedProduct) {
  const fullUrl = base_url + 'products/detailed';

  let response = await fetch(
    new Request(fullUrl, {
      method: 'POST',
      headers: {
        // "Access-Control-Allow-Origin": "*",
        // "Access-Control-Allow-Headers": "Origin, X-Requested-With, Content-Type, Accept",
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(detailedProduct),
    }),
  );
  if (response.status === 200) {
    return response.json();
  } else {
    return null;
  }
}
